import { ref } from 'vue';

import { FeedbackService } from '@/services';

const useFetchFormFeedback = () => {
  const form = ref({});

  const fetchFeedback = async () => {
    form.value = await FeedbackService.getFeedbackForm('search_helpful_form');
  };

  const promise = fetchFeedback();

  return {
    form,
    promise,
  };
};

export default useFetchFormFeedback;
